import * as React from 'react';

import { t } from 'state/intl/translations';

import { CenterHeader, LeftHeader, RightHeader } from '../loyalty-history.styled';
import { Transaction, TransactionTable } from '../types';

import { HEADER_IDS } from './constants';

const getTransactionTableHistoryStructure = (
  transactions: Transaction[],
  monthHeader: string
): TransactionTable => ({
  head: [
    {
      dateTime: <LeftHeader>{monthHeader}</LeftHeader>,
      rewards: <CenterHeader>{t(HEADER_IDS.POINTS)}</CenterHeader>,
      purchaseAmount: <RightHeader>{t(HEADER_IDS.PURCHASE_AMOUNT)}</RightHeader>,
    },
  ],
  body: transactions,
});

export default getTransactionTableHistoryStructure;
